import { AxiosResponse } from "axios";
import { fork, put, takeLatest } from "redux-saga/effects";
import { TopRibbon } from "../../Apis/AuthApiServices";
import { loadingTopRibbon, setTopRibbon } from "../Slice/TopRibbonSlice";

function* onLoadTopRibbonAsync({ payload }: any) {
  const params = new URLSearchParams();
  let doctorId: any = localStorage.getItem("doctorId");
  params.append("doctorId", doctorId);
  try {
    const result: AxiosResponse = yield TopRibbon(params);
    if (result?.data?.digitalRxStatusCode === 200) {
      yield put(
        setTopRibbon({
          TopRibbonData: result?.data?.response[0],
          isLoading: false,
          error: false,
        })
      );
    } else {
      yield put(
        setTopRibbon({
          TopRibbonData: [],
          error: true,
          isLoading: false,
          message: result?.data?.digitalRxStatusMessage,
        })
      );
    }
  } catch (error: any) {
    yield put(
      setTopRibbon({
        TopRibbonData: [],
        error: true,
        isLoading: false,
        message: "Try Again After Some Time!",
      })
    );
  }
}

function* onLoadTopRibbon() {
  yield takeLatest(loadingTopRibbon.type, onLoadTopRibbonAsync);
}

const TopRibbonSaga = [fork(onLoadTopRibbon)];
export default TopRibbonSaga;
